import { Resource } from '@prismamedia/one-crud-react';

export const NewsletterConfig: Resource = {
  singular: 'newsletter',
  plural: 'newsletters',
  basePath: 'newsletter',
  keyProperty: 'id',
};
